<cw-menu (menuToggle)="onMenuToggle()">
  <button
    *transloco="let t"
    #switchButton
    slot="trigger"
    class="cx-icon-button-md d-flex align-items-center justify-content-center"
    [style.--mat-icon-button-icon-size]="'32px'"
    [matTooltip]="t('Applications')"
    mat-icon-button
    data-cy="switch-button-button">
    <mat-icon class="d-flex align-items-center justify-content-center"
      [svgIcon]="menuOpen ? 'app_switch_active' : 'app_switch_inactive'"/>
  </button>
  @if (routerFacade.isReplenishmentSignal()) {
    <cw-menu-item active="false" (click)="onAppSelected(ROUTES.REP_EVOLUTION)"
      data-cy="repevolution-menu-item">
      <div class="d-flex">
        <mat-icon class="app-icon mr-s" svgIcon="app_icon"/>
        <!--Dev note: Next line is non-translatable-->
        <span> REPevolution </span>
      </div>
    </cw-menu-item>
  }
  @if (routerFacade.isRepEvolutionSignal()) {
    <cw-menu-item active="false" (click)="onAppSelected(ROUTES.REPLENISHMENT)"
      data-cy="replenishment-menu-item">
      <div class="d-flex">
        <mat-icon class="app-icon mr-s" svgIcon="app_icon"/>
        <!--Dev note: Next line is non-translatable-->
        <span> Replenishment </span>
      </div>
    </cw-menu-item>
  }
</cw-menu>
